import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { userSelector } from './user/user-slice';

export const GuardedComponent = ({component: Component, ...props}) => {
  const user = useSelector(userSelector);

  useEffect(() => {
    if (user) {
      sessionStorage.removeItem('currentPath')
      return
    }

    const url = `${document.location.pathname}${document.location.search}`;

    if (!sessionStorage.getItem('currentPath')) {
      sessionStorage.setItem('currentPath', url)
    }

    document.location.href = `/login`
  }, [])

  return (<Component {...props} />
  )
}
